import React from "react";
import { connect } from "react-redux";

import { toggleShowPrice, toggleShowUVP } from "../redux/actionCreators";
import LeadingText from "../LeadingText";
import SupportingText from "../SupportingText";
import { ArrowRight, ArrowLeft } from "../Icons";
import PriceToggleContainer from "../PriceToggleContainer";
import LogoutContainer from "../LogoutContainer";
import ProfileHeader from "../ProfileHeader";
import FullScreenOverlay from "../FullScreenOverlay";
import FloatingActionButton from "../FloatingActionButton";
import BaseButton from "../BaseButton";
import Impressum from "../Impressum";
import Adress from "../Adress";
import SocialMedia from "../SocialMedia";
import Contact from "../Contact";

const overlayElements = [
  /*eslint-disable */
  {
    label: "Liefer- & Rechnungsadresse",
    component: () => <Adress />
  },
  //{ label: "Kontakt aufnehmen", component: () => <Contact /> },
  //{ label: "Social Media", component: () => <SocialMedia /> },
  { label: "Impressum", component: () => <Impressum /> }
  /*eslint-disable */
];

const mapStateToProps = ({ auth, ui }) => ({
  showPrice: ui.showPrice,
  showUVP: ui.showUVP,
  currentUser: auth.currentUser
});

const mapDispatchToProps = dispatch => ({
  togglePrice: () => {
    dispatch(toggleShowPrice());
  },
  toggleUVP: () => dispatch(toggleShowUVP())
});

function ProfileBox({ isLastElement, el, onClick }) {
  return (
    <div
      className={`w-full flex flex items-center justify-center ${
        isLastElement ? "" : "border-b border-grey-light"
      }`}
    >
      <BaseButton className="w-full" onClick={() => onClick(el)}>
        <ProfileRow text={el.label} />
      </BaseButton>
    </div>
  );
}

function ProfileContainer({ children }) {
  return (
    <div className="w-full bg-white rounded shadow-blur-lg px-4">
      {children}
    </div>
  );
}

function ProfileRow({ text }) {
  return (
    <div className="w-full flex items-center justify-between py-4">
      <SupportingText textColor="black" textSize="base">
        {text}
      </SupportingText>
      <ArrowRight stroke="#EF5753" width="40px" height="20px" />
    </div>
  );
}

class ProfileView extends React.Component {
  constructor() {
    super();
    this.state = {
      showOverlay: false,
      activeElement: null
    };
  }

  showFullScreenOverlay = activeElement => {
    this.setState({
      showOverlay: true,
      activeElement
    });
  };

  hideFullScreenOverlay = () => {
    this.setState({
      showOverlay: false,
      activeElement: null
    });
  };

  renderFullScreenOverlay = (showOverlay, el) => {
    return (
      <FullScreenOverlay
        axis="x"
        startingPosition="positive"
        show={showOverlay}
      >
        <div className="w-full h-full bg-grey-lighter px-3 pb-3">
          {el !== null ? (
            <div className="w-full h-full">
              <div
                style={{
                  height: "10%"
                }}
                className="w-full flex items-center justify-between"
              >
                <FloatingActionButton
                  bgColor="blue-darker"
                  size="xs"
                  onClick={() => this.hideFullScreenOverlay()}
                >
                  <ArrowLeft stroke="white" height="15px" />
                </FloatingActionButton>

                <LeadingText
                  textColor="grey-darkest"
                  fontWeight="lg"
                  textAlign="center"
                >
                  {el.label}
                </LeadingText>
                <div />
              </div>
              <div
                style={{
                  maxHeight: "90%"
                }}
                className="w-full rounded bg-white px-4 overflow-y-scroll"
              >
                {el.component()}
              </div>
            </div>
          ) : null}
        </div>
      </FullScreenOverlay>
    );
  };

  render() {
    const {
      currentUser,
      showPrice,
      showUVP,
      togglePrice,
      toggleUVP
    } = this.props;
    const { showOverlay, activeElement } = this.state;
    return (
      <div
        style={{
          paddingBottom: "60px"
        }}
        className="w-full h-full"
      >
        <div className="w-full h-full overflow-y-scroll overflow-x-auto py-3 relative">
          <ProfileHeader
            companyName={currentUser && currentUser.companyName}
            clientID={currentUser && currentUser.clientID}
          />
          <div className="my-8">
            <PriceToggleContainer
              showPrice={showPrice}
              showUVP={showUVP}
              togglePrice={togglePrice}
              toggleUVP={toggleUVP}
            />
          </div>
          <ProfileContainer>
            {overlayElements.map((el, key) => (
              <ProfileBox
                key={key}
                el={el}
                isLastElement={key === overlayElements.length - 1}
                onClick={activeEl => this.showFullScreenOverlay(activeEl)}
              />
            ))}
          </ProfileContainer>
        </div>
        <div
          style={{
            height: "60px"
          }}
          className="absolute pin-l pin-b w-full py-2"
        >
          <LogoutContainer />
        </div>
        {this.renderFullScreenOverlay(showOverlay, activeElement)}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileView);



// WEBPACK FOOTER //
// ./src/ProfileView/ProfileView.js